(function (root, factory) {
  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (root) root.BadgeBuzzProductDesignPDP = api;
})(typeof window !== "undefined" ? window : globalThis, function () {
  "use strict";

  var REVISION_MODE = "paid-order-revision";
  var REVISION_ENDPOINT = "/apps/bb-portal/portal/v1/artwork-revisions/";

  function text(value) {
    return String(value == null ? "" : value).trim();
  }

  function escapeHtml(value) {
    return text(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function showToast(win, title, message, variant) {
    if (!win.BBToast || typeof win.BBToast.show !== "function") return;
    win.BBToast.show({
      variant: variant || "error",
      title: title,
      message: message || "",
    });
  }

  function normalizePreviews(message) {
    var values =
      (message && (message.previews || message.Previews)) ||
      (message &&
        message.data &&
        (message.data.previews || message.data.previewFiles)) ||
      [];
    return Array.isArray(values)
      ? values
          .map(function (item) {
            return typeof item === "string"
              ? item
              : item &&
                  (item.url ||
                    item.previewUrl ||
                    item.preview_url ||
                    item.path);
          })
          .filter(Boolean)
      : [];
  }

  function mount(options) {
    options = options || {};
    var win =
      options.window ||
      (options.root && options.root.ownerDocument.defaultView) ||
      (typeof window !== "undefined" ? window : null);
    var root = options.root;
    var actionsRoot = options.actionsRoot;
    var runtimeRoot = options.runtimeRoot;
    var product = options.product || {};
    var Design =
      options.controllerApi ||
      (win && win.BadgeBuzzProductDesignController);
    if (
      !win ||
      !root ||
      !actionsRoot ||
      !runtimeRoot ||
      !Design ||
      typeof Design.mount !== "function"
    ) {
      throw new Error("Regular PDP design adapter is not configured.");
    }

    var revisionToken = "";
    try {
      revisionToken =
        new win.URL(win.location.href).searchParams.get("bbRevision") || "";
    } catch (error) {}
    var revisionMode = revisionToken ? REVISION_MODE : "shopping";
    var revisionContext = null;
    var revisionContextPromise = null;
    var revisionSubmitKey = "";
    var revisionRedirectTimer = null;
    var designButton = actionsRoot.querySelector("[data-bb-open-zakeke]");
    var uploadButton = actionsRoot.querySelector(
      "[data-bb-upload-button], #bb-upload-btn",
    );
    var banner =
      actionsRoot.querySelector("[data-bb-summary-revision-banner]") ||
      actionsRoot.querySelector("#bb-revision-banner") ||
      win.document.querySelector("#bb-revision-banner");
    var savedDesignNotice = actionsRoot.querySelector(
      "[data-bb-saved-design-notice]",
    );
    var designText = actionsRoot.querySelector(
      "[data-bb-design-primary-text]",
    );
    var designSubtext = actionsRoot.querySelector(
      "[data-bb-design-primary-subtext]",
    );
    var defaultDesignText = designText ? designText.textContent : "";
    var defaultDesignSubtext = designSubtext ? designSubtext.textContent : "";
    var savedDesignId = "";
    var deepLinkTimer = null;
    var deepLinkListeners = [];
    var revisionState =
      win.BBArtworkRevisionModel &&
      typeof win.BBArtworkRevisionModel.initialState === "function"
        ? win.BBArtworkRevisionModel.initialState(revisionMode)
        : { mode: revisionMode, status: revisionToken ? "loading" : "idle" };

    if (revisionToken)
      win.document.documentElement.dataset.bbRevisionHydrating = "1";

    function transitionRevision(event) {
      if (
        win.BBArtworkRevisionModel &&
        typeof win.BBArtworkRevisionModel.transition === "function"
      )
        revisionState = win.BBArtworkRevisionModel.transition(
          revisionState,
          event,
        );
      return revisionState;
    }

    function setRevisionBanner(message, isHtml) {
      if (!banner) return;
      banner.textContent = "";
      if (isHtml) banner.innerHTML = message || "";
      else banner.textContent = message || "";
      banner.hidden = !message;
    }

    function selection() {
      var readiness = win.BBProductActionReadiness;
      if (!readiness || typeof readiness.requireReady !== "function") {
        throw new Error("Product selection is still loading.");
      }
      return readiness.requireReady(root);
    }

    function lockRevisionContext() {
      if (!revisionToken) return;
      root
        .querySelectorAll(
          'input[name="quantity"], select[name="quantity"], [name^="properties["], [name="id"], select, input[type="number"], input[type="text"], input[type="radio"], input[type="checkbox"], textarea, button, .bb-visual-radio-btn',
        )
        .forEach(function (field) {
          if (
            !field ||
            !field.matches ||
            field.matches(".bb-summary *") ||
            field.closest("[data-bb-design-modal]") ||
            field.closest("[data-bb-design-review]") ||
            field === designButton ||
            field === uploadButton ||
            field.dataset.bbLocked === "1"
          )
            return;
          field.dataset.bbLocked = "1";
          field.disabled = true;
        });
    }

    function loadRevisionContext() {
      if (!revisionToken) return Promise.resolve(null);
      if (revisionContext) return Promise.resolve(revisionContext);
      if (revisionContextPromise) return revisionContextPromise;
      revisionContextPromise = win
        .fetch(REVISION_ENDPOINT + encodeURIComponent(revisionToken), {
          credentials: "same-origin",
        })
        .then(function (response) {
          if (response.ok) return response.json();
          return response.text().then(function (message) {
            throw new Error(message || "Could not load revision context.");
          });
        })
        .then(function (context) {
          if (
            !context ||
            !context.design_id ||
            (context.status !== "open" && context.status !== "required")
          ) {
            throw new Error("Revision session unavailable.");
          }
          revisionContext = context;
          transitionRevision("CONTEXT_READY");
          setRevisionBanner(
            context.order_name
              ? "<strong>Editing artwork for order " +
                  escapeHtml(context.order_name) +
                  "</strong> · Keep product options, quantity, and selected date unchanged."
              : "<strong>Editing artwork for this order.</strong> Keep product options, quantity, and selected date unchanged.",
            true,
          );
          return context;
        })
        .catch(function (error) {
          transitionRevision("CONTEXT_ERROR");
          setRevisionBanner(
            "Revision session needs refresh. " +
              (error.message || "Reopen this order from your dashboard."),
          );
          if (designButton) designButton.disabled = true;
          throw error;
        });
      return revisionContextPromise;
    }

    function prefillRevision() {
      if (!revisionToken) return Promise.resolve();
      return loadRevisionContext().then(function (context) {
        var quantity = Number(
          context.expected_quantity || context.expectedQuantity,
        );
        if (Number.isSafeInteger(quantity) && quantity > 0) {
          root
            .querySelectorAll('input[name="quantity"], select[name="quantity"]')
            .forEach(function (field) {
              field.value = String(quantity);
              field.dispatchEvent(new win.Event("change", { bubbles: true }));
            });
        }
        (Array.isArray(context.attributes) ? context.attributes : []).forEach(
          function (attribute) {
            var field = root.querySelector(
              '[name="properties[' + attribute.key + ']"]',
            );
            if (!field) return;
            field.value = attribute.value;
            field.dispatchEvent(new win.Event("change", { bubbles: true }));
          },
        );
        lockRevisionContext();
      });
    }

    function finishRevisionHydration() {
      if (!revisionToken) return;
      delete win.document.documentElement.dataset.bbRevisionHydrating;
      win.dispatchEvent(new win.Event("bb:revision-hydrated"));
    }

    function getRevisionSubmitKey() {
      if (revisionSubmitKey) return revisionSubmitKey;
      revisionSubmitKey =
        win.crypto && typeof win.crypto.randomUUID === "function"
          ? win.crypto.randomUUID()
          : "review-" + win.Date.now() + "-" + Math.random().toString(16).slice(2);
      return revisionSubmitKey;
    }

    function submitRevisionPayload(payload, selected) {
      transitionRevision("SAVE");
      return loadRevisionContext()
        .then(function (context) {
          var expectedQuantity = Number(
            context.expected_quantity || context.expectedQuantity,
          );
          if (
            Number.isFinite(expectedQuantity) &&
            Number(selected.quantity) !== expectedQuantity
          ) {
            throw new Error(
              "Quantity must match your paid order before submitting.",
            );
          }
          return win.fetch(
            REVISION_ENDPOINT +
              encodeURIComponent(revisionToken) +
              "/submit",
            {
              method: "POST",
              credentials: "same-origin",
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Idempotency-Key": getRevisionSubmitKey(),
              },
              body: JSON.stringify({ payload: payload }),
            },
          );
        })
        .then(function (response) {
          if (response.ok) return response.json().catch(function () {
            return {};
          });
          return response.text().then(function (message) {
            throw new Error(message || "Could not submit revision.");
          });
        })
        .then(function (result) {
          transitionRevision("SUBMIT_OK");
          showToast(
            win,
            "Revision request submitted",
            "Your updated design was sent to our team for review.",
            "success",
          );
          if (options.navigateOnRevisionComplete !== false) {
            revisionRedirectTimer = win.setTimeout(function () {
              win.location.assign("/pages/account#orders");
            }, 900);
          }
          return result;
        })
        .catch(function (error) {
          transitionRevision("SUBMIT_ERROR");
          showToast(
            win,
            "Couldn't submit this revision",
            error.message || "Please try again.",
          );
          throw error;
        });
    }

    function artworkRevisionPayload(artwork, selected) {
      var designId = text(
        artwork &&
          artwork.properties &&
          artwork.properties._zakeke_design_id,
      );
      if (!designId) throw new Error("A saved design is required.");
      return {
        zakekeMessageType: 0,
        designId: designId,
        designID: designId,
        quantity: Number(selected.quantity),
        previews: Array.isArray(artwork.previewUrls)
          ? artwork.previewUrls.slice()
          : [],
      };
    }

    function onCommitArtwork(artwork, selected) {
      if (!revisionToken) return null;
      return submitRevisionPayload(
        artworkRevisionPayload(artwork, selected),
        selected,
      );
    }

    function onSaveDesign(context) {
      if (!revisionToken) return null;
      var designId = text(
        context.designId ||
          (context.message &&
            (context.message.designId ||
              context.message.designID ||
              context.message.compositionId)),
      );
      return submitRevisionPayload(
        {
          zakekeMessageType: 0,
          designId: designId,
          designID: designId,
          quantity: Number(context.selection.quantity),
          previews: normalizePreviews(context.message),
        },
        context.selection,
      ).then(function (result) {
        if (
          runtimeRoot.bbProductDesignRuntime &&
          typeof runtimeRoot.bbProductDesignRuntime.closeModal === "function"
        )
          runtimeRoot.bbProductDesignRuntime.closeModal();
        return result;
      });
    }

    var controller = Design.mount({
      root: root,
      actionsRoot: actionsRoot,
      runtimeRoot: runtimeRoot,
      product: product,
      mode: "cart",
      selection: selection,
      beforeOpen: revisionToken ? loadRevisionContext : null,
      onCommitArtwork: revisionToken ? onCommitArtwork : null,
      onSaveDesign: revisionToken ? onSaveDesign : null,
    });

    function onBlankDesign(event) {
      var selected;
      try {
        selected = selection();
      } catch (error) {
        return;
      }
      if (
        text(selected.properties && selected.properties.Design).toLowerCase() !==
        "blank"
      )
        return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (revisionToken) {
        showToast(
          win,
          "Revision mode",
          "This order cannot be replaced with a blank product.",
          "warning",
        );
        return;
      }
      if (typeof win.bbAddValidatedSelectionToCart !== "function") {
        showToast(
          win,
          "Cart is unavailable",
          "Please refresh the page and try again.",
        );
        return;
      }
      var actionDetail =
        event.detail && typeof event.detail === "object"
          ? event.detail
          : null;
      var actionButton =
        (actionDetail && actionDetail.bbActionButton) || designButton;
      var label =
        actionButton.querySelector("[data-bb-sticky-primary-label]") ||
        actionButton.querySelector("[data-bb-design-primary-text]") ||
        actionButton.querySelector("strong") ||
        actionButton.querySelector("span");
      Promise.resolve(
        win.bbAddValidatedSelectionToCart({
          button: actionButton,
          label: label,
          selection: selected,
          defaultText: "Add to Cart",
          loadingText: "ADDING…",
          errorText: "TRY AGAIN",
          onError: function (error) {
            showToast(
              win,
              "Couldn't add to cart",
              error && error.message ? error.message : "Please try again.",
            );
          },
        }),
      ).catch(function () {});
    }

    function onRevisionUpload(event) {
      if (!revisionToken) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showToast(
        win,
        "Revision mode",
        "Please use Edit design in the proof review to replace this file.",
        "warning",
      );
    }

    if (designButton)
      designButton.addEventListener("click", onBlankDesign, true);
    if (uploadButton)
      uploadButton.addEventListener("click", onRevisionUpload, true);

    function blankDesignSelected() {
      var field =
        root.querySelector('input[name="properties[Design]"]:checked') ||
        root.querySelector('select[name="properties[Design]"]') ||
        root.querySelector('input[name="properties[Design]"]');
      return Boolean(field && text(field.value).toLowerCase() === "blank");
    }

    function renderSavedDesignIntent() {
      var active = Boolean(
        savedDesignId && !revisionToken && !blankDesignSelected(),
      );
      if (savedDesignNotice) savedDesignNotice.hidden = !active;
      if (designText)
        designText.textContent = active
          ? "CUSTOMIZE SAVED DESIGN"
          : defaultDesignText;
      if (designSubtext)
        designSubtext.textContent = active
          ? "Reopen your artwork with these options"
          : defaultDesignSubtext;
      if (!designButton) return;
      if (active) {
        designButton.dataset.bbSavedDesign = "true";
        if (savedDesignNotice && savedDesignNotice.id)
          designButton.setAttribute("aria-describedby", savedDesignNotice.id);
      } else {
        delete designButton.dataset.bbSavedDesign;
        if (
          savedDesignNotice &&
          designButton.getAttribute("aria-describedby") === savedDesignNotice.id
        )
          designButton.removeAttribute("aria-describedby");
      }
    }

    function onSavedDesign(event) {
      if (!savedDesignId || revisionToken || blankDesignSelected()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var opening;
      try {
        opening = controller.openDesigner(savedDesignId);
      } catch (error) {
        showToast(win, "Review your product options", error.message, "warning");
        return;
      }
      Promise.resolve(opening)
        .then(stripDesignParam)
        .catch(function (error) {
          showToast(
            win,
            "Couldn't load the customizer",
            error.message || "Please try again.",
          );
        });
    }

    function onSavedDesignSelectionChange() {
      renderSavedDesignIntent();
    }

    if (designButton)
      designButton.addEventListener("click", onSavedDesign, true);
    root.addEventListener("change", onSavedDesignSelectionChange);
    root.addEventListener("input", onSavedDesignSelectionChange);

    function clearDeepLinkWatch() {
      if (deepLinkTimer) win.clearInterval(deepLinkTimer);
      deepLinkTimer = null;
      deepLinkListeners.forEach(function (binding) {
        binding.target.removeEventListener(binding.name, binding.handler);
      });
      deepLinkListeners = [];
    }

    function stripDesignParam() {
      try {
        var clean = new win.URL(win.location.href);
        clean.searchParams.delete("bbDesign");
        win.history.replaceState({}, win.document.title, clean.toString());
      } catch (error) {}
    }

    function beginDeepLinkWatch(designId) {
      var readiness = win.BBProductActionReadiness;
      var deadline = win.Date.now() + 12000;

      function readySelection() {
        if (
          !readiness ||
          typeof readiness.stateFor !== "function" ||
          typeof readiness.evaluate !== "function" ||
          typeof readiness.snapshot !== "function"
        )
          return null;
        var state = readiness.stateFor(root);
        return readiness.evaluate(state).ready
          ? readiness.snapshot(state)
          : null;
      }

      function attempt() {
        if (!readySelection()) {
          if (win.Date.now() >= deadline) {
            clearDeepLinkWatch();
            setRevisionBanner(
              "Finish choosing your options to reopen this design.",
            );
          }
          return;
        }
        clearDeepLinkWatch();
        if (revisionToken) lockRevisionContext();
        controller.openDesigner(designId).catch(function (error) {
          showToast(
            win,
            "Couldn't load the customizer",
            error.message || "Please try again.",
          );
        });
        stripDesignParam();
      }

      [
        "input",
        "change",
        "bb:price-update",
        "bb:delivery-date-change",
        "bb:delivery-date-ready",
      ].forEach(function (name) {
        var binding = { target: win.document, name: name, handler: attempt };
        deepLinkListeners.push(binding);
        binding.target.addEventListener(name, attempt);
      });
      deepLinkTimer = win.setInterval(attempt, 400);
      attempt();
    }

    function startDeepLink() {
      var designId = "";
      try {
        designId =
          new win.URL(win.location.href).searchParams.get("bbDesign") || "";
      } catch (error) {}
      if (!designId) {
        finishRevisionHydration();
        return;
      }
      if (!revisionToken) {
        savedDesignId = designId;
        renderSavedDesignIntent();
        return;
      }
      Promise.resolve(revisionToken ? prefillRevision() : null)
        .catch(function () {})
        .then(function () {
          finishRevisionHydration();
          beginDeepLinkWatch(designId);
        });
    }

    if (win.document.readyState === "loading")
      win.document.addEventListener("DOMContentLoaded", startDeepLink, {
        once: true,
      });
    else startDeepLink();

    var disconnect = controller.disconnect;
    controller.disconnect = function () {
      clearDeepLinkWatch();
      if (revisionRedirectTimer) win.clearTimeout(revisionRedirectTimer);
      win.document.removeEventListener("DOMContentLoaded", startDeepLink);
      if (designButton)
        designButton.removeEventListener("click", onBlankDesign, true);
      if (uploadButton)
        uploadButton.removeEventListener("click", onRevisionUpload, true);
      if (designButton)
        designButton.removeEventListener("click", onSavedDesign, true);
      root.removeEventListener("change", onSavedDesignSelectionChange);
      root.removeEventListener("input", onSavedDesignSelectionChange);
      disconnect();
    };
    return controller;
  }

  return { mount: mount };
});
